/* ============================================================================
   Mon Casque M1 — Outil de datation des coques US M1
   Fichier : assets/helmet-dating.js

   Un seul fichier pour les trois langues.
   - Le balisage (titres, questions, libellés) vit dans le corps de l'article
     et est traduit par Localize / Translate & Adapt.
   - Les chaînes générées dynamiquement (périodes, confiance, caractéristiques,
     informations complémentaires) vivent dans l'objet I18N ci-dessous.

   La logique ne lit JAMAIS le texte visible : elle s'appuie uniquement sur les
   attributs `id`, `name` et `value` des <input>. Traduire un libellé ne peut
   donc rien casser.

   Le script ne fait rien si #helmet-id-quiz est absent de la page : il peut
   être chargé globalement sans risque.
   ========================================================================= */

(function () {
  'use strict';

  /* ---------------------------------------------------------------------
     1. DICTIONNAIRE
     --------------------------------------------------------------------- */

  var I18N = {

    fr: {
      progress: 'Question {n} sur {total}',
      selectAnswer: 'Veuillez sélectionner une réponse avant de continuer.',
      estimatedPeriod: 'Période estimée',
      confidenceLabel: 'Confiance : ',

      confVeryHigh: 'très élevée',
      confHigh: 'élevée',
      confMedium: 'moyenne',
      confLow: 'faible',
      confVeryLow: 'très faible',

      p1941_late1942: 'Début 1941 – Fin 1942',
      pLate1942_early1943: 'Fin 1942 – Début 1943',
      pEarly1943_mid1943: 'Début 1943 – Mi-1943',
      p1941_1943: '1941 – 1943',
      p1943: 'Début 1943 – Fin 1943',
      pLate1943_Oct1944: 'Fin 1943 – Octobre 1944',
      pOct1944_Nov1944: 'Octobre 1944 – Novembre 1944',
      pNov1944_early1945: 'Novembre 1944 – Début 1945',
      pEarly1945_Aug1945: 'Début 1945 – Août 1945',
      pNov1944_Aug1945: 'Novembre 1944 – Août 1945',
      pLate1943_Nov1944: 'Fin 1943 – Novembre 1944',
      pLate1943_Aug1945: 'Fin 1943 – Août 1945',
      p1941_Nov1944: '1941 – Novembre 1944',
      pNov1944_postwar: 'Novembre 1944 – Après-guerre',
      pUndetermined: 'Indéterminée',
      pUndeterminedPost1945: 'Indéterminée ou post-1945',

      cLoopsFixedRect: 'Attaches de jugulaire fixes rectangulaires (typique McCord)',
      cLoopsFixedRound: 'Attaches de jugulaire fixes arrondies (typique Schlueter)',
      cLoopsHinged: 'Attaches de jugulaire articulées',
      cRimFront: 'Jonc avec soudure à l\u2019avant',
      cRimRear: 'Jonc avec soudure à l\u2019arrière',
      cRimStandardFront: 'Jonc en acier standard avec soudure à l\u2019avant',
      cRimStainless: 'Jonc en acier inoxydable',
      cRimStandard: 'Jonc en acier standard',
      cRimUnknown: 'Matériau du jonc indéterminé',
      cLoopStainless: 'Attaches en acier inoxydable',
      cLoopStandard: 'Attaches en acier standard',
      cLoopUnknown: 'Matériau des attaches indéterminé',
      cAtypical: 'Combinaison de caractéristiques atypique',
      cPartiallyAtypical: 'Combinaison de caractéristiques partiellement atypique',
      cInsufficient: 'Caractéristiques insuffisantes pour une datation précise',
      cInsufficientDating: 'Caractéristiques insuffisantes pour une datation',
      cUnknownSeamPos: 'Position de la soudure du jonc indéterminée',
      cUnknownLoopType: 'Type d\u2019attaches de jugulaire indéterminé',
      cMfgMcCord: 'Fabricant : McCord Radiator (principal fabricant)',
      cMfgSchlueter: 'Fabricant : Schlueter Manufacturing (production débutée en 1943)',
      cLotLow: 'Numéro de lot bas (aide à la datation précise)',
      cLotMid: 'Numéro de lot moyen (aide à la datation précise)',
      cLotHigh: 'Numéro de lot élevé (aide à la datation précise)',

      aEarlyMcCord: 'Ce casque correspond aux premières productions de M1 par McCord. Les attaches fixes rectangulaires et le jonc avec soudure à l\u2019avant sont caractéristiques de cette période. Ces modèles ont été principalement utilisés pendant l\u2019opération Torch en Afrique du Nord (1942) et les premières campagnes en Italie (1943). Comme tous les casques de la Seconde Guerre mondiale, ils ont continué à être utilisés jusqu\u2019à la fin du conflit et même au-delà.',
      aEarlySchlueter: 'Ce casque correspond aux premières productions de Schlueter, qui a commencé à fabriquer des casques M1 en 1943. Les attaches fixes arrondies sont caractéristiques de ce fabricant. Ces casques ont été principalement utilisés lors des campagnes d\u2019Italie et du Pacifique en 1944, compte tenu du délai d\u2019un an environ entre la production et l\u2019utilisation sur le terrain. Comme tous les casques de la Seconde Guerre mondiale, ils ont continué à être utilisés jusqu\u2019à la fin du conflit et même au-delà.',
      aMidHinged: 'Ce casque correspond à la période intermédiaire de production. L\u2019introduction des attaches articulées en novembre 1943 a amélioré la durabilité du casque. En raison du délai entre production et déploiement, ces casques ont commencé à apparaître en nombre significatif sur le terrain vers fin 1944 et début 1945, notamment pendant la bataille des Ardennes et la campagne d\u2019Allemagne. Comme tous les casques de la Seconde Guerre mondiale, ils ont continué à être utilisés jusqu\u2019à la fin du conflit et même au-delà.',
      aLateOct44: 'Ce casque correspond à une période très courte de production (octobre-novembre 1944) où le jonc a été changé pour de l\u2019acier standard mais la soudure était encore à l\u2019avant. Cette période de transition est assez rare et recherchée par les collectionneurs. En raison du délai entre production et déploiement, ces casques ont été principalement utilisés pendant les dernières phases de la guerre en Europe (1945). Comme tous les casques de la Seconde Guerre mondiale, ils ont continué à être utilisés jusqu\u2019à la fin du conflit et même au-delà.',
      aEndRearSeam: 'Ce casque correspond à la dernière version de production pendant la Seconde Guerre mondiale. Le déplacement de la soudure du jonc à l\u2019arrière en novembre 1944 était la dernière modification majeure de la conception. En raison du délai entre production et déploiement, ces casques ont été principalement utilisés pendant l\u2019occupation d\u2019après-guerre et certains ont pu être utilisés pendant la guerre de Corée. Comme tous les casques de la Seconde Guerre mondiale, ils ont continué à être utilisés jusqu\u2019à la fin du conflit et même au-delà.',
      aUndetermined: 'Les caractéristiques identifiables de votre casque sont insuffisantes pour établir une datation précise. Une expertise plus approfondie avec examen physique serait nécessaire pour déterminer sa période de fabrication.',
      aAtypicalFixed: 'Votre casque présente des attaches fixes, ce qui est caractéristique des premières productions (1941-1943). Cependant, la combinaison avec d\u2019autres caractéristiques est atypique, ce qui pourrait indiquer des réparations ou modifications ultérieures. La datation se base principalement sur le type d\u2019attaches de jugulaire.',
      aAtypicalHingedFront: 'Votre casque présente des attaches articulées avec une soudure du jonc à l\u2019avant, ce qui correspond à la période intermédiaire de production (fin 1943 – novembre 1944). Certaines caractéristiques sont difficiles à déterminer, mais ces éléments clés permettent une datation approximative.',
      aAtypicalHingedRear: 'Votre casque présente des attaches articulées avec une soudure du jonc à l\u2019arrière, ce qui correspond à la dernière période de production pendant la Seconde Guerre mondiale (novembre 1944 – août 1945). Certaines caractéristiques sont difficiles à déterminer, mais ces éléments clés permettent une datation approximative.',
      aHingedUnknownSeam: 'Votre casque présente des attaches articulées, ce qui indique une production à partir de fin 1943. Sans pouvoir déterminer la position de la soudure du jonc, il est difficile d\u2019affiner davantage la datation. La période proposée couvre toute la durée d\u2019utilisation des attaches articulées pendant la Seconde Guerre mondiale.',
      aFrontSeamUnknownLoop: 'Votre casque présente une soudure du jonc à l\u2019avant, ce qui était caractéristique de toutes les productions jusqu\u2019en novembre 1944. Sans pouvoir déterminer le type d\u2019attaches, il est difficile d\u2019affiner davantage la datation. Une expertise plus approfondie serait nécessaire.',
      aRearSeamUnknownLoop: 'Votre casque présente une soudure du jonc à l\u2019arrière, ce qui indique une production à partir de novembre 1944. Cette caractéristique a continué à être utilisée après la guerre. Sans pouvoir déterminer le type d\u2019attaches, il est difficile d\u2019affiner davantage la datation. Une expertise plus approfondie serait nécessaire.',
      aInsufficient: 'Les caractéristiques identifiables de votre casque sont insuffisantes pour établir une datation. Une expertise plus approfondie avec examen physique serait nécessaire.'
    },

    en: {
      progress: 'Question {n} of {total}',
      selectAnswer: 'Please select an answer before continuing.',
      estimatedPeriod: 'Estimated period',
      confidenceLabel: 'Confidence: ',

      confVeryHigh: 'very high',
      confHigh: 'high',
      confMedium: 'medium',
      confLow: 'low',
      confVeryLow: 'very low',

      p1941_late1942: 'Early 1941 – Late 1942',
      pLate1942_early1943: 'Late 1942 – Early 1943',
      pEarly1943_mid1943: 'Early 1943 – Mid-1943',
      p1941_1943: '1941 – 1943',
      p1943: 'Early 1943 – Late 1943',
      pLate1943_Oct1944: 'Late 1943 – October 1944',
      pOct1944_Nov1944: 'October 1944 – November 1944',
      pNov1944_early1945: 'November 1944 – Early 1945',
      pEarly1945_Aug1945: 'Early 1945 – August 1945',
      pNov1944_Aug1945: 'November 1944 – August 1945',
      pLate1943_Nov1944: 'Late 1943 – November 1944',
      pLate1943_Aug1945: 'Late 1943 – August 1945',
      p1941_Nov1944: '1941 – November 1944',
      pNov1944_postwar: 'November 1944 – Post-war',
      pUndetermined: 'Undetermined',
      pUndeterminedPost1945: 'Undetermined or post-1945',

      cLoopsFixedRect: 'Fixed rectangular chinstrap loops (typical McCord)',
      cLoopsFixedRound: 'Fixed rounded chinstrap loops (typical Schlueter)',
      cLoopsHinged: 'Hinged chinstrap loops',
      cRimFront: 'Front seam rim',
      cRimRear: 'Rear seam rim',
      cRimStandardFront: 'Standard steel rim with front seam',
      cRimStainless: 'Stainless steel rim',
      cRimStandard: 'Standard steel rim',
      cRimUnknown: 'Undetermined rim material',
      cLoopStainless: 'Stainless steel loops',
      cLoopStandard: 'Standard steel loops',
      cLoopUnknown: 'Undetermined loop material',
      cAtypical: 'Atypical combination of features',
      cPartiallyAtypical: 'Partially atypical combination of features',
      cInsufficient: 'Insufficient characteristics for precise dating',
      cInsufficientDating: 'Insufficient characteristics for dating',
      cUnknownSeamPos: 'Undetermined rim seam position',
      cUnknownLoopType: 'Undetermined chinstrap loop type',
      cMfgMcCord: 'Manufacturer: McCord Radiator (main manufacturer)',
      cMfgSchlueter: 'Manufacturer: Schlueter Manufacturing (production started in 1943)',
      cLotLow: 'Low lot number (helps with precise dating)',
      cLotMid: 'Medium lot number (helps with precise dating)',
      cLotHigh: 'High lot number (helps with precise dating)',

      aEarlyMcCord: 'This helmet corresponds to the early M1 production by McCord. The fixed rectangular loops and front seam rim are characteristic of this period. These models were mainly used during Operation Torch in North Africa (1942) and the early Italian campaigns (1943). Like all World War II helmets, they continued to be used until the end of the conflict and even beyond.',
      aEarlySchlueter: 'This helmet corresponds to the early production by Schlueter, which began manufacturing M1 helmets in 1943. The fixed rounded loops are characteristic of this manufacturer. These helmets were mainly used during the Italian and Pacific campaigns in 1944, considering the approximately one-year delay between production and field use. Like all World War II helmets, they continued to be used until the end of the conflict and even beyond.',
      aMidHinged: 'This helmet corresponds to the intermediate production period. The introduction of hinged loops in November 1943 improved helmet durability. Due to the delay between production and deployment, these helmets began appearing in significant numbers in the field around late 1944 and early 1945, particularly during the Battle of the Bulge and the German campaign. Like all World War II helmets, they continued to be used until the end of the conflict and even beyond.',
      aLateOct44: 'This helmet corresponds to a very short production period (October–November 1944) when the rim was changed to standard steel but the seam was still at the front. This transition period is quite rare and sought after by collectors. Due to the delay between production and deployment, these helmets were mainly used during the final phases of the war in Europe (1945). Like all World War II helmets, they continued to be used until the end of the conflict and even beyond.',
      aEndRearSeam: 'This helmet corresponds to the last production version during World War II. Moving the rim seam to the rear in November 1944 was the last major design modification. Due to the delay between production and deployment, these helmets were mainly used during the post-war occupation and some may have been used during the Korean War. Like all World War II helmets, they continued to be used until the end of the conflict and even beyond.',
      aUndetermined: 'The identifiable characteristics of your helmet are insufficient to establish a precise dating. Further expert examination with physical inspection would be necessary to determine its manufacturing period.',
      aAtypicalFixed: 'Your helmet has fixed loops, which is characteristic of early production (1941–1943). However, the combination with other features is atypical, which could indicate later repairs or modifications. The dating is primarily based on the chinstrap loop type.',
      aAtypicalHingedFront: 'Your helmet has hinged loops with a front seam rim, which corresponds to the intermediate production period (late 1943 – November 1944). Some characteristics are difficult to determine, but these key elements allow for an approximate dating.',
      aAtypicalHingedRear: 'Your helmet has hinged loops with a rear seam rim, which corresponds to the last production period during World War II (November 1944 – August 1945). Some characteristics are difficult to determine, but these key elements allow for an approximate dating.',
      aHingedUnknownSeam: 'Your helmet has hinged loops, which indicates production from late 1943 onwards. Without being able to determine the position of the rim seam, it is difficult to refine the dating further. The proposed period covers the entire duration of use of hinged loops during World War II.',
      aFrontSeamUnknownLoop: 'Your helmet has a front seam rim, which was characteristic of all production until November 1944. Without being able to determine the loop type, it is difficult to refine the dating further. Further expert examination would be necessary.',
      aRearSeamUnknownLoop: 'Your helmet has a rear seam rim, which indicates production from November 1944 onwards. This feature continued to be used after the war. Without being able to determine the loop type, it is difficult to refine the dating further. Further expert examination would be necessary.',
      aInsufficient: 'The identifiable characteristics of your helmet are insufficient to establish a dating. Further expert examination with physical inspection would be necessary.'
    },

    de: {
      progress: 'Frage {n} von {total}',
      selectAnswer: 'Bitte wählen Sie eine Antwort aus, bevor Sie fortfahren.',
      estimatedPeriod: 'Geschätzter Zeitraum',
      confidenceLabel: 'Konfidenz: ',

      confVeryHigh: 'sehr hoch',
      confHigh: 'hoch',
      confMedium: 'mittel',
      confLow: 'gering',
      confVeryLow: 'sehr gering',

      p1941_late1942: 'Anfang 1941 – Ende 1942',
      pLate1942_early1943: 'Ende 1942 – Anfang 1943',
      pEarly1943_mid1943: 'Anfang 1943 – Mitte 1943',
      p1941_1943: '1941 – 1943',
      p1943: 'Anfang 1943 – Ende 1943',
      pLate1943_Oct1944: 'Ende 1943 – Oktober 1944',
      pOct1944_Nov1944: 'Oktober 1944 – November 1944',
      pNov1944_early1945: 'November 1944 – Anfang 1945',
      pEarly1945_Aug1945: 'Anfang 1945 – August 1945',
      pNov1944_Aug1945: 'November 1944 – August 1945',
      pLate1943_Nov1944: 'Ende 1943 – November 1944',
      pLate1943_Aug1945: 'Ende 1943 – August 1945',
      p1941_Nov1944: '1941 – November 1944',
      pNov1944_postwar: 'November 1944 – Nachkriegszeit',
      pUndetermined: 'Unbestimmt',
      pUndeterminedPost1945: 'Unbestimmt oder nach 1945',

      cLoopsFixedRect: 'Feste rechteckige Kinnriemenbügel (typisch McCord)',
      cLoopsFixedRound: 'Feste runde Kinnriemenbügel (typisch Schlueter)',
      cLoopsHinged: 'Bewegliche (klappbare) Kinnriemenbügel',
      cRimFront: 'Randeinfassung mit vorderer Schweißnaht',
      cRimRear: 'Randeinfassung mit hinterer Schweißnaht',
      cRimStandardFront: 'Randeinfassung aus Normalstahl mit vorderer Schweißnaht',
      cRimStainless: 'Randeinfassung aus rostfreiem Stahl',
      cRimStandard: 'Randeinfassung aus Normalstahl',
      cRimUnknown: 'Material der Randeinfassung unbestimmt',
      cLoopStainless: 'Bügel aus rostfreiem Stahl',
      cLoopStandard: 'Bügel aus Normalstahl',
      cLoopUnknown: 'Material der Bügel unbestimmt',
      cAtypical: 'Untypische Merkmalskombination',
      cPartiallyAtypical: 'Teilweise untypische Merkmalskombination',
      cInsufficient: 'Merkmale für eine genaue Datierung unzureichend',
      cInsufficientDating: 'Merkmale für eine Datierung unzureichend',
      cUnknownSeamPos: 'Position der Schweißnaht unbestimmt',
      cUnknownLoopType: 'Typ der Kinnriemenbügel unbestimmt',
      cMfgMcCord: 'Hersteller: McCord Radiator (Haupthersteller)',
      cMfgSchlueter: 'Hersteller: Schlueter Manufacturing (Produktionsbeginn 1943)',
      cLotLow: 'Niedrige Losnummer (hilft bei der genauen Datierung)',
      cLotMid: 'Mittlere Losnummer (hilft bei der genauen Datierung)',
      cLotHigh: 'Hohe Losnummer (hilft bei der genauen Datierung)',

      aEarlyMcCord: 'Dieser Helm entspricht der frühen M1-Produktion von McCord. Die festen rechteckigen Bügel und die vordere Schweißnaht der Randeinfassung sind kennzeichnend für diesen Zeitraum. Diese Modelle wurden vor allem während der Operation Torch in Nordafrika (1942) und in den ersten Italienfeldzügen (1943) eingesetzt. Wie alle Helme des Zweiten Weltkriegs wurden sie bis zum Kriegsende und darüber hinaus weiterverwendet.',
      aEarlySchlueter: 'Dieser Helm entspricht der frühen Produktion von Schlueter, das 1943 mit der Fertigung von M1-Helmen begann. Die festen runden Bügel sind kennzeichnend für diesen Hersteller. Diese Helme wurden angesichts der etwa einjährigen Verzögerung zwischen Produktion und Fronteinsatz vor allem in den Feldzügen in Italien und im Pazifik im Jahr 1944 verwendet. Wie alle Helme des Zweiten Weltkriegs wurden sie bis zum Kriegsende und darüber hinaus weiterverwendet.',
      aMidHinged: 'Dieser Helm entspricht der mittleren Produktionsphase. Die Einführung der beweglichen Bügel im November 1943 verbesserte die Haltbarkeit des Helms. Aufgrund der Verzögerung zwischen Produktion und Auslieferung traten diese Helme erst gegen Ende 1944 und Anfang 1945 in nennenswerter Zahl an der Front auf, insbesondere während der Ardennenoffensive und des Feldzugs in Deutschland. Wie alle Helme des Zweiten Weltkriegs wurden sie bis zum Kriegsende und darüber hinaus weiterverwendet.',
      aLateOct44: 'Dieser Helm entspricht einer sehr kurzen Produktionsphase (Oktober–November 1944), in der die Randeinfassung auf Normalstahl umgestellt wurde, die Schweißnaht sich aber noch vorne befand. Diese Übergangsphase ist recht selten und bei Sammlern begehrt. Aufgrund der Verzögerung zwischen Produktion und Auslieferung wurden diese Helme vor allem in den letzten Phasen des Krieges in Europa (1945) eingesetzt. Wie alle Helme des Zweiten Weltkriegs wurden sie bis zum Kriegsende und darüber hinaus weiterverwendet.',
      aEndRearSeam: 'Dieser Helm entspricht der letzten Produktionsvariante des Zweiten Weltkriegs. Die Verlegung der Schweißnaht nach hinten im November 1944 war die letzte wesentliche Konstruktionsänderung. Aufgrund der Verzögerung zwischen Produktion und Auslieferung wurden diese Helme vor allem in der Nachkriegsbesatzung eingesetzt; einige kamen möglicherweise im Koreakrieg zum Einsatz. Wie alle Helme des Zweiten Weltkriegs wurden sie bis zum Kriegsende und darüber hinaus weiterverwendet.',
      aUndetermined: 'Die erkennbaren Merkmale Ihres Helms reichen für eine genaue Datierung nicht aus. Eine eingehendere Begutachtung mit physischer Untersuchung wäre erforderlich, um den Herstellungszeitraum zu bestimmen.',
      aAtypicalFixed: 'Ihr Helm weist feste Bügel auf, was für die frühe Produktion (1941–1943) kennzeichnend ist. Die Kombination mit den übrigen Merkmalen ist jedoch untypisch, was auf spätere Reparaturen oder Veränderungen hindeuten kann. Die Datierung stützt sich hier vor allem auf den Bügeltyp.',
      aAtypicalHingedFront: 'Ihr Helm weist bewegliche Bügel und eine vordere Schweißnaht auf, was der mittleren Produktionsphase entspricht (Ende 1943 – November 1944). Einige Merkmale lassen sich schwer bestimmen, doch diese Schlüsselelemente erlauben eine ungefähre Datierung.',
      aAtypicalHingedRear: 'Ihr Helm weist bewegliche Bügel und eine hintere Schweißnaht auf, was der letzten Produktionsphase des Zweiten Weltkriegs entspricht (November 1944 – August 1945). Einige Merkmale lassen sich schwer bestimmen, doch diese Schlüsselelemente erlauben eine ungefähre Datierung.',
      aHingedUnknownSeam: 'Ihr Helm weist bewegliche Bügel auf, was auf eine Produktion ab Ende 1943 hindeutet. Ohne die Position der Schweißnaht bestimmen zu können, lässt sich die Datierung nicht weiter eingrenzen. Der angegebene Zeitraum umfasst die gesamte Verwendungsdauer beweglicher Bügel im Zweiten Weltkrieg.',
      aFrontSeamUnknownLoop: 'Ihr Helm weist eine vordere Schweißnaht auf, was für die gesamte Produktion bis November 1944 kennzeichnend war. Ohne den Bügeltyp bestimmen zu können, lässt sich die Datierung nicht weiter eingrenzen. Eine eingehendere Begutachtung wäre erforderlich.',
      aRearSeamUnknownLoop: 'Ihr Helm weist eine hintere Schweißnaht auf, was auf eine Produktion ab November 1944 hindeutet. Dieses Merkmal wurde auch nach dem Krieg beibehalten. Ohne den Bügeltyp bestimmen zu können, lässt sich die Datierung nicht weiter eingrenzen. Eine eingehendere Begutachtung wäre erforderlich.',
      aInsufficient: 'Die erkennbaren Merkmale Ihres Helms reichen für eine Datierung nicht aus. Eine eingehendere Begutachtung mit physischer Untersuchung wäre erforderlich.'
    }
  };

  /* ---------------------------------------------------------------------
     2. LANGUE
     --------------------------------------------------------------------- */

  function detectLocale() {
    var raw = '';
    if (window.Shopify && window.Shopify.locale) raw = String(window.Shopify.locale);
    if (!raw) raw = document.documentElement.getAttribute('lang') || '';
    if (!raw) {
      var m = window.location.pathname.match(/^\/([a-zA-Z]{2})(?:-[a-zA-Z]{2})?(?:\/|$)/);
      raw = m ? m[1] : '';
    }
    raw = raw.toLowerCase();
    if (raw.indexOf('de') === 0) return 'de';
    if (raw.indexOf('en') === 0) return 'en';
    return 'fr';
  }

  var LOCALE = 'fr';

  function t(key) {
    var pack = I18N[LOCALE] || I18N.fr;
    return (key in pack) ? pack[key] : (I18N.fr[key] || '');
  }

  /* ---------------------------------------------------------------------
     3. ÉTAT ET NAVIGATION
     --------------------------------------------------------------------- */

  var STEPS = [
    'helmet-quiz-intro',
    'helmet-quiz-q1',
    'helmet-quiz-q2',
    'helmet-quiz-q3',
    'helmet-quiz-q4',
    'helmet-quiz-q5',
    'helmet-quiz-q6',
    'helmet-quiz-results'
  ];

  var RESULTS_STEP = STEPS.length - 1;
  var TOTAL_QUESTIONS = 6;

  var RADIO_BY_STEP = {
    'helmet-quiz-q1': 'helmet-quiz-hasLetterS',
    'helmet-quiz-q2': 'helmet-quiz-lotNumber',
    'helmet-quiz-q3': 'helmet-quiz-rimSeam',
    'helmet-quiz-q4': 'helmet-quiz-rimMaterial',
    'helmet-quiz-q5': 'helmet-quiz-chinStrapType',
    'helmet-quiz-q6': 'helmet-quiz-loopMaterial'
  };

  var root, current = 0, answers = {};

  function $(id) { return document.getElementById(id); }

  function goTo(index) {
    if (index < 0 || index >= STEPS.length) return;
    var prev = $(STEPS[current]);
    if (prev) prev.classList.remove('active');
    current = index;
    var next = $(STEPS[current]);
    if (next) {
      next.classList.add('active');
      next.setAttribute('tabindex', '-1');
      next.focus({ preventScroll: true });
    }
    updateProgress();
  }

  function updateProgress() {
    var el = $('helmet-quiz-progress');
    if (!el) return;
    if (current === 0 || current === RESULTS_STEP) { el.textContent = ''; return; }
    el.textContent = t('progress')
      .replace('{n}', String(current))
      .replace('{total}', String(TOTAL_QUESTIONS));
  }

  function showError(stepId, message) {
    var el = $('helmet-quiz-error-' + stepId.replace('helmet-quiz-', ''));
    if (el) el.textContent = message || '';
  }

  function captureStep(stepId) {
    var name = RADIO_BY_STEP[stepId];
    if (!name) return true;
    var checked = root.querySelector('input[name="' + name + '"]:checked');
    if (!checked) {
      showError(stepId, t('selectAnswer'));
      return false;
    }
    showError(stepId, '');
    answers[name] = checked.value;
    return true;
  }

  /* ---------------------------------------------------------------------
     4. QUESTION 5 — visibilité des options « attaches fixes »
        Correctif : lorsque le marquage « S » est indéterminé, les DEUX
        options fixes restent proposées, quelles que soient les réponses
        précédentes. Dans la version d'origine, l'utilisateur pouvait se
        retrouver sans aucune option « attaches fixes ».
     --------------------------------------------------------------------- */

  function setOptionVisible(optionId, visible) {
    var wrap = $(optionId);
    if (!wrap) return;
    wrap.classList.toggle('is-hidden', !visible);
    if (!visible) {
      var input = wrap.querySelector('input');
      if (input && input.checked) {
        input.checked = false;
        delete answers['helmet-quiz-chinStrapType'];
      }
    }
  }

  function refreshChinStrapOptions() {
    var hasS = answers['helmet-quiz-hasLetterS'];
    var showRounded = (hasS === 'yes' || hasS === 'unknown' || !hasS);
    var showRect    = (hasS === 'no'  || hasS === 'unknown' || !hasS);
    setOptionVisible('helmet-quiz-opt-fixedRounded', showRounded);
    setOptionVisible('helmet-quiz-opt-fixedRectangular', showRect);
    setOptionVisible('helmet-quiz-opt-hinged', true);
    setOptionVisible('helmet-quiz-opt-unknownType', true);
  }

  /* ---------------------------------------------------------------------
     5. CALCUL DU RÉSULTAT
     --------------------------------------------------------------------- */

  function rimMaterialKey() {
    var v = answers['helmet-quiz-rimMaterial'];
    if (v === 'stainlessSteel') return 'cRimStainless';
    if (v === 'standardSteel') return 'cRimStandard';
    return 'cRimUnknown';
  }

  function loopMaterialKey() {
    var v = answers['helmet-quiz-loopMaterial'];
    if (v === 'loopStainlessSteel') return 'cLoopStainless';
    if (v === 'loopStandardSteel') return 'cLoopStandard';
    return 'cLoopUnknown';
  }

  function computeResult() {
    var seam = answers['helmet-quiz-rimSeam'];
    var rim = answers['helmet-quiz-rimMaterial'];
    var loops = answers['helmet-quiz-chinStrapType'];
    var loopMat = answers['helmet-quiz-loopMaterial'];
    var lot = answers['helmet-quiz-lotNumber'];
    var hasS = answers['helmet-quiz-hasLetterS'];

    var rimSoftStainless = (rim === 'stainlessSteel' || rim === 'unknownMaterial');
    var noLot = (lot === 'noNumber');

    // Fabricant
    var manufacturer = 'unknown';
    if (hasS === 'yes') manufacturer = 'schlueter';
    else if (hasS === 'no') manufacturer = 'mccord';
    else if (hasS === 'unknown' && loops === 'fixedRounded') manufacturer = 'schlueter';
    else if (hasS === 'unknown' && loops === 'fixedRectangular') manufacturer = 'mccord';

    var period, confidence, chars = [], info, mfgMentioned = false;

    // A — McCord, attaches fixes rectangulaires, front seam
    if ((manufacturer === 'mccord' || manufacturer === 'unknown') &&
        loops === 'fixedRectangular' && seam === 'frontSeam' && rimSoftStainless) {

      if (lot === 'lowNumber')       { period = 'p1941_late1942';      confidence = 'confVeryHigh'; }
      else if (lot === 'midNumber')  { period = 'pLate1942_early1943'; confidence = 'confHigh'; }
      else if (lot === 'highNumber') { period = 'pEarly1943_mid1943';  confidence = 'confHigh'; }
      else                           { period = 'p1941_1943';          confidence = 'confMedium'; }

      chars = ['cLoopsFixedRect', 'cRimFront', rimMaterialKey(), loopMaterialKey()];
      info = 'aEarlyMcCord';
      mfgMentioned = true;

    // B — Schlueter, attaches fixes arrondies, front seam
    } else if ((manufacturer === 'schlueter' || manufacturer === 'unknown') &&
               loops === 'fixedRounded' && seam === 'frontSeam' && rimSoftStainless) {

      period = 'p1943';
      confidence = noLot ? 'confMedium' : 'confHigh';
      chars = ['cLoopsFixedRound', 'cRimFront', rimMaterialKey(), loopMaterialKey()];
      info = 'aEarlySchlueter';
      mfgMentioned = true;

    // C — Attaches articulées, front seam, jonc inox
    } else if (seam === 'frontSeam' && rimSoftStainless && loops === 'hinged') {

      period = 'pLate1943_Oct1944';
      confidence = noLot ? 'confMedium' : 'confHigh';
      chars = ['cLoopsHinged', 'cRimFront', rimMaterialKey(), loopMaterialKey()];
      info = 'aMidHinged';

    // D — Transition : front seam, jonc acier standard
    } else if (seam === 'frontSeam' && rim === 'standardSteel' && loops === 'hinged') {

      period = 'pOct1944_Nov1944';
      confidence = noLot ? 'confMedium' : 'confVeryHigh';
      chars = ['cLoopsHinged', 'cRimStandardFront', loopMaterialKey()];
      info = 'aLateOct44';

    // E — Rear seam
    } else if (seam === 'rearSeam' && (rim === 'standardSteel' || rim === 'unknownMaterial') && loops === 'hinged') {

      if (loopMat === 'loopStainlessSteel') {
        period = 'pNov1944_early1945';
        confidence = noLot ? 'confMedium' : 'confVeryHigh';
      } else if (loopMat === 'loopStandardSteel') {
        period = 'pEarly1945_Aug1945';
        confidence = noLot ? 'confMedium' : 'confVeryHigh';
      } else {
        period = 'pNov1944_Aug1945';
        confidence = 'confMedium';
      }
      chars = ['cLoopsHinged', 'cRimRear', rimMaterialKey(), loopMaterialKey()];
      info = 'aEndRearSeam';

    // F — Rien d'exploitable
    } else if (seam === 'unknownSeam' && loops === 'unknownType') {

      period = 'pUndeterminedPost1945';
      confidence = 'confLow';
      chars = ['cInsufficient', 'cUnknownSeamPos', 'cUnknownLoopType'];
      info = 'aUndetermined';

    // G — Combinaisons atypiques
    } else if (loops === 'fixedRectangular' || loops === 'fixedRounded') {

      period = 'p1941_1943';
      confidence = 'confLow';
      chars = [loops === 'fixedRectangular' ? 'cLoopsFixedRect' : 'cLoopsFixedRound', 'cAtypical'];
      info = 'aAtypicalFixed';
      mfgMentioned = true;

    } else if (loops === 'hinged' && seam === 'frontSeam') {

      period = 'pLate1943_Nov1944';
      confidence = 'confMedium';
      chars = ['cLoopsHinged', 'cRimFront', 'cPartiallyAtypical'];
      info = 'aAtypicalHingedFront';

    } else if (loops === 'hinged' && seam === 'rearSeam') {

      period = 'pNov1944_Aug1945';
      confidence = 'confMedium';
      chars = ['cLoopsHinged', 'cRimRear', 'cPartiallyAtypical'];
      info = 'aAtypicalHingedRear';

    } else if (loops === 'hinged') {

      period = 'pLate1943_Aug1945';
      confidence = 'confLow';
      chars = ['cLoopsHinged', 'cUnknownSeamPos'];
      info = 'aHingedUnknownSeam';

    } else if (seam === 'frontSeam') {

      period = 'p1941_Nov1944';
      confidence = 'confVeryLow';
      chars = ['cRimFront', 'cUnknownLoopType'];
      info = 'aFrontSeamUnknownLoop';

    } else if (seam === 'rearSeam') {

      period = 'pNov1944_postwar';
      confidence = 'confVeryLow';
      chars = ['cRimRear', 'cUnknownLoopType'];
      info = 'aRearSeamUnknownLoop';

    } else {

      period = 'pUndetermined';
      confidence = 'confVeryLow';
      chars = ['cInsufficientDating'];
      info = 'aInsufficient';
    }

    // Fabricant, s'il n'est pas déjà implicite dans les caractéristiques
    if (!mfgMentioned) {
      if (manufacturer === 'mccord') chars.push('cMfgMcCord');
      else if (manufacturer === 'schlueter') chars.push('cMfgSchlueter');
    }

    // Numéro de lot
    if (lot === 'lowNumber') chars.push('cLotLow');
    else if (lot === 'midNumber') chars.push('cLotMid');
    else if (lot === 'highNumber') chars.push('cLotHigh');

    return {
      period: period,
      confidence: confidence,
      chars: chars,
      info: info,
      manufacturer: manufacturer
    };
  }

  /* ---------------------------------------------------------------------
     6. AFFICHAGE
     --------------------------------------------------------------------- */

  function renderResult(result) {
    var box = $('helmet-quiz-result-content');
    var list = $('helmet-quiz-characteristics-list');
    var info = $('helmet-quiz-additional-info');
    if (!box || !list || !info) return;

    box.textContent = '';
    list.textContent = '';
    info.textContent = '';

    var wrap = document.createElement('div');
    wrap.style.textAlign = 'center';

    var h3 = document.createElement('h3');
    h3.className = 'result-title';
    h3.textContent = t('estimatedPeriod');

    var p = document.createElement('p');
    p.className = 'result-period';
    p.textContent = t(result.period);

    var conf = document.createElement('p');
    conf.className = 'result-confidence';
    conf.textContent = t('confidenceLabel');
    var confVal = document.createElement('span');
    confVal.style.fontWeight = '600';
    confVal.textContent = t(result.confidence);
    conf.appendChild(confVal);

    wrap.appendChild(h3);
    wrap.appendChild(p);
    wrap.appendChild(conf);
    box.appendChild(wrap);

    result.chars.forEach(function (key) {
      var li = document.createElement('li');
      li.textContent = t(key);
      list.appendChild(li);
    });

    info.textContent = t(result.info);
  }

  /* ---------------------------------------------------------------------
     6 bis. FORMULAIRE DE CAPTATION — affichage selon la langue

     Trois formulaires Omnisend cohabitent dans l'écran de résultat, un par
     langue. On masque les deux qui ne correspondent pas à la locale.

     Si un seul formulaire est posé (FR par exemple), les deux autres
     conteneurs sont simplement absents et la fonction les ignore.
     --------------------------------------------------------------------- */

  function showCaptureForLocale() {
    ['fr', 'en', 'de'].forEach(function (lang) {
      var el = $('helmet-capture-' + lang);
      if (el) el.style.display = (lang === LOCALE) ? '' : 'none';
    });
  }

  /* ---------------------------------------------------------------------
     7. INITIALISATION
     --------------------------------------------------------------------- */

  function reset() {
    root.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
    Object.keys(answers).forEach(function (k) { delete answers[k]; });
    Object.keys(RADIO_BY_STEP).forEach(function (stepId) { showError(stepId, ''); });
    refreshChinStrapOptions();
    goTo(0);
  }

  function init() {
    root = $('helmet-id-quiz');
    if (!root) return;

    LOCALE = detectLocale();
    root.setAttribute('lang', LOCALE);

    var startBtn = $('helmet-quiz-start-btn');
    if (startBtn) startBtn.addEventListener('click', function () { goTo(1); });

    root.querySelectorAll('.helmet-quiz-next-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepId = STEPS[current];
        if (!captureStep(stepId)) return;
        if (stepId === 'helmet-quiz-q1' || stepId === 'helmet-quiz-q4') refreshChinStrapOptions();
        goTo(current + 1);
      });
    });

    root.querySelectorAll('.helmet-quiz-prev-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showError(STEPS[current], '');
        goTo(current - 1);
      });
    });

    var submitBtn = $('helmet-quiz-submit-btn');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!captureStep(STEPS[current])) return;
        renderResult(computeResult());
        goTo(RESULTS_STEP);
      });
    }

    var restartBtn = $('helmet-quiz-restart-btn');
    if (restartBtn) restartBtn.addEventListener('click', reset);

    // Clic n'importe où sur la ligne d'option — limité au quiz, pas au document.
    root.addEventListener('click', function (e) {
      var opt = e.target.closest ? e.target.closest('.option') : null;
      if (!opt || !root.contains(opt)) return;
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'LABEL') return;
      var input = opt.querySelector('input[type="radio"]');
      if (input) input.checked = true;
    });

    refreshChinStrapOptions();
    showCaptureForLocale();
    updateProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
